module.exports = __webpack_public_path__ + "img/17.3.TP.9e3d62f4.png";